import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from './Button';
const takeaways = ['What AI can honestly do for it', 'Roughly what it would cost to build', 'How long before it pays for itself'];
export function StartEngagement() {
  return <section id="start-engagement" className="py-20 md:py-28 border-t border-border bg-card relative overflow-hidden bg-grid-schematic" data-id="element-95">
      <div className="container relative" data-id="element-96">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-98">
            <div className="flex items-center gap-3 mb-4" data-id="element-99">
              <p className="font-mono text-xs font-medium text-muted-foreground tracking-[0.2em] uppercase" data-id="element-100">
                Start an engagement
              </p>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight leading-tight text-foreground" data-id="element-101">
              Leave with an honest answer, either way.
            </h2>
            <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed" data-id="element-102">
              Thirty minutes, no deck, no discovery workshop, no obligation.
              Bring the process that frustrates you most — the one buried in
              spreadsheets, emails, and tribal knowledge.
            </p>
            <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed" data-id="element-103">
              If the answer is "not much yet", we'll say that too, and tell you
              what to fix first — so the call pays off even if we never work
              together.
            </p>
            <p className="mt-4 text-sm font-mono text-muted-foreground/70" data-id="element-104">
              We run a small number of engagements at a time, so the calendar is
              the constraint.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bracket-frame border border-border bg-background p-8 md:p-10" data-id="element-105">
            <p className="font-mono text-xs font-medium text-muted-foreground mb-6 tracking-widest uppercase" data-id="element-106">
              You'll leave with
            </p>
            <ul className="space-y-0 mb-8 border-t border-border" data-id="element-107">
              {takeaways.map((item, i) => <li key={item} className="flex items-start gap-3 py-3.5 border-b border-border" data-id="element-108">
                  <Check className="h-4 w-4 text-signal shrink-0 mt-1" aria-hidden="true" data-id="element-109" />
                  <span className="text-foreground text-base" data-id="element-110">{item}</span>
                </li>)}
            </ul>
            <Button size="lg" className="w-full sm:w-auto group rounded-none font-mono text-xs uppercase tracking-widest" data-id="element-111">
              Claim your 30 minutes
              <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-112" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}